import { render, staticRenderFns } from "./UrlTweaker.vue?vue&type=template&id=425c3386"
import script from "./UrlTweaker.vue?vue&type=script&lang=js"
export * from "./UrlTweaker.vue?vue&type=script&lang=js"
import style0 from "./UrlTweaker.vue?vue&type=style&index=0&id=425c3386&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports